import { Option } from '@sapphire/result';

/**
 * Whether the survey's global price override is still the system-managed
 * PurePrice value after an Apply.
 *
 * It stays `true` only while the flag was already on AND the override the user
 * is about to save is identical to the persisted one. Any edit, clear, or
 * price-type switch that changes the override hands pricing control back to the
 * user and returns `false` — which is what stops the auto PurePrice recompute.
 * A no-op Apply (the drawer re-seeds the managed override and the user changes
 * nothing) leaves it `true`.
 */
export function resolveDefaultPurePriceOverride(
  currentDefaultPurePriceOverride: boolean,
  currentOverride: Option<number>,
  appliedOverride: Option<number>,
): boolean {
  if (!currentDefaultPurePriceOverride) {
    return false;
  }

  return currentOverride.match({
    some: (rate) =>
      appliedOverride.map((applied) => applied === rate).unwrapOr(false),
    none: () => appliedOverride.isNone(),
  });
}
